import ShowNotes from "../component/ShowNotes";
function Notes() {
  return (
    <div className="flex-grow">
      <ShowNotes />
    </div>
  );
}

export default Notes;
